// Lives in fleet/ (not site/): SiteDrilldownView only fetches SiteStatus (no
// `environments` field) — FleetSite is the only shape that currently carries it.
import { ConnectionBadge } from './ConnectionBadge';
import type { SiteEnvironment } from '../../lib/types';

const ID = 'em-mgr--site--environments';

export function SiteEnvironments({ environments }: { environments: SiteEnvironment[] | undefined }) {
  if (!environments || environments.length === 0) return null;

  return (
    // Indented inset panel so environments read as belonging to the row above.
    <div
      data-id={ID}
      className="ml-6 divide-y divide-slate-200/70 overflow-hidden rounded-md bg-slate-100/70 dark:divide-slate-700/70 dark:bg-slate-800/50"
    >
      {environments.map((env) => (
        <div
          key={env.name}
          data-id="em-mgr--site--environments--row"
          className="flex flex-wrap items-center gap-2 px-3 py-1.5 text-sm"
        >
          <span className="font-medium">{env.name}</span>
          <span className="text-xs text-slate-500 dark:text-slate-400">({env.kind})</span>
          <ConnectionBadge state={env.connection} />
          <span className="truncate text-xs text-slate-500 dark:text-slate-400">{env.wpUrl}</span>
        </div>
      ))}
    </div>
  );
}
